import { Collection, Space } from '@tribeplatform/gql-client/types'

export const NO_COLLECTION_ID = 'no-collection'

export enum CollectionMenuViewStyle {
  Simple = 'simple',
  Collapsible = 'collapsible',
  Heading = 'heading',
}

export enum CollectionMenuSpaceFilter {
  All = 'all',
  Joined = 'joined',
  NotJoined = 'notJoined',
}

export type CollectionMenuItem = {
  id: string
  enabled: boolean
}

export type CollectionMenuDetailedItem = CollectionMenuItem & {
  name: string
}

export type CollectionMenuProps = {
  items?: CollectionMenuItem[]
  viewStyle: CollectionMenuViewStyle
  spaceFilter?: CollectionMenuSpaceFilter
}

export type NoCollectionEntry = {
  id: typeof NO_COLLECTION_ID
  name: string
  customOrderingIndex: number
  spaces?: {
    nodes: Space[]
    totalCount: number
  }
}

export type CollectionMenuEntry = Collection | NoCollectionEntry

export const isNoCollectionEntry = (
  entry: CollectionMenuEntry,
): entry is NoCollectionEntry => entry.id === NO_COLLECTION_ID

/**
 * A locale group surfaces as a single nav entry: only its primary space is
 * shown (linked to the group base path, which redirects to the member's locale
 * variant). Non-primary variant spaces are hidden. When the localeGroup field
 * wasn't fetched, nothing is hidden.
 */
const isHiddenLocaleVariant = (space: Space): boolean =>
  !!space.localeGroupId &&
  !!space.localeGroup &&
  space.id !== space.localeGroup.primarySpaceId

export const getCollectionMenuEntrySpaces = (
  entry: CollectionMenuEntry,
): Space[] =>
  (isNoCollectionEntry(entry)
    ? (entry.spaces?.nodes ?? [])
    : (entry.spaces?.edges?.map(({ node }) => node) ?? [])
  ).filter(space => !isHiddenLocaleVariant(space))
